import { SxProps, Theme } from '@mui/material/styles';
import { cssColorPrimary, formUi } from '../../constants/globalcss';

// Header styles
export const headerContainerStyles: SxProps<Theme> = {
  mb: 3,
  position: 'relative',
};

export const backButtonContainerStyles: SxProps<Theme> = {
  left: 0,
  position: 'absolute',
  top: 0,
};

export const titleStyles: SxProps<Theme> = {
  color: '#1e293b',
  fontSize: { sm: '2rem', xs: '1.5rem' },
  fontWeight: 600,
  textAlign: 'center',
};

// Workflow details styles — auto-fit so column count matches visible cells (no empty 5th column on lg)
export const detailsGridStyles: SxProps<Theme> = {
  borderBottom: '1px solid rgba(22, 56, 96, 0.12)',
  borderTop: '1px solid rgba(22, 56, 96, 0.12)',
  display: 'grid',
  gap: 2,
  gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 200px), 1fr))',
  mb: 2.5,
  mt: 0,
  py: 2.5,
  width: '100%',
};

export const detailLabelStyles: SxProps<Theme> = {
  fontSize: '0.7rem',
  fontWeight: 500,
  letterSpacing: '0.05em',
  mb: 0.25,
  textTransform: 'uppercase',
};

export const detailValueStyles: SxProps<Theme> = {
  fontSize: '0.9rem',
  fontWeight: 500,
};

export const chipStyles: SxProps<Theme> = {
  backgroundColor: cssColorPrimary,
  borderRadius: 2,
  color: 'white',
  fontSize: '0.75rem',
  fontWeight: 500,
};

/** Intro, assignment metadata, NDC table — uses full paper width */
export const workflowSummaryBandStyles: SxProps<Theme> = {
  alignItems: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  width: '100%',
};

/** One column inside `workflowResponseColumnStyles` — full width of that column */
export const workflowFormStackStyles: SxProps<Theme> = {
  alignItems: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  gap: formUi.spacing.sectionGap,
  minWidth: 0,
  width: '100%',
};

/** Response fields + actions only — list-mode width, centered */
export const workflowResponseColumnStyles: SxProps<Theme> = {
  alignItems: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: formUi.spacing.formColumnListMax,
  minWidth: 0,
  mx: 'auto',
  pt: 2,
  width: '100%',
};

export const workflowFormFieldSlotStyles: SxProps<Theme> = {
  minWidth: 0,
  width: '100%',
};

export const centeredTextStyles: SxProps<Theme> = {
  py: 4,
  textAlign: 'center',
};

export const buttonContainerStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  pt: 2,
  width: '100%',
};

// Loading and error styles
export const loadingContainerStyles: SxProps<Theme> = {
  alignItems: 'center',
  display: 'flex',
  height: '50vh',
  justifyContent: 'center',
};

export const errorContainerStyles: SxProps<Theme> = {
  margin: '0 auto',
  maxWidth: 800,
  padding: 3,
};

export const errorAlertStyles: SxProps<Theme> = {
  mb: 2,
};

// Toast styles
export const toastStyles: SxProps<Theme> = {
  '& .MuiAlert-icon, & .MuiIconButton-root': {
    color: 'white',
  },
  width: '100%',
};

export const getToastBackgroundColor = (
  severity: 'success' | 'error'
): string => (severity === 'error' ? '#c62828' : '#2e7d32');
